import { ClipboardCheck, Type, Contrast, Move, ToggleRight, CheckCircle2 } from "lucide-react";

export function AuraAuditResults() {
  const auditItems = [
    {
      icon: Type,
      title: "Typography",
      status: "Pass",
      description: "Scale is consistent, headings are clear. Minor guidance needed on exact weights and line-heights per level."
    },
    {
      icon: Contrast,
      title: "Color & contrast",
      status: "Pass",
      description: "Meets AA contrast on text and controls. Use amber/red only for alerts and errors."
    },
    {
      icon: Move,
      title: "Motion & reduce",
      status: "Pass",
      description: "Subtle transitions only; no critical info conveyed by animation alone."
    },
    {
      icon: ToggleRight,
      title: "States & affordances",
      status: "Pass",
      description: "Hover, focus, active, and disabled styles covered with clear outlines and contrast."
    }
  ];

  return (
    <div className="mt-8 rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="px-4 py-3 border-b border-slate-200 flex items-center gap-2">
        <div className="h-4 w-4 p-1 rounded-md bg-emerald-50 text-emerald-600 border border-emerald-100 flex items-center justify-center">
          <ClipboardCheck className="h-2.5 w-2.5" />
        </div>
        <h2 className="text-[15px] font-medium tracking-tight text-slate-900">Audit results</h2>
      </div>
      
      <div className="p-4 space-y-3">
        {auditItems.map((item, index) => (
          <div key={index} className="rounded-xl border border-slate-200 p-3">
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-2">
                <div className="h-4 w-4 p-1 rounded-md bg-emerald-50 text-emerald-600 border border-emerald-100 flex items-center justify-center">
                  <item.icon className="h-2.5 w-2.5" />
                </div>
                <div className="text-[15px] font-medium text-slate-900">{item.title}</div>
              </div>
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border border-emerald-200 bg-emerald-50 text-emerald-700">
                <CheckCircle2 className="h-3.5 w-3.5" />
                {item.status}
              </span>
            </div>
            <p className="mt-2 text-[13px] text-slate-600">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}